
import { UserProfileKey } from '../../types';

export const userProfile: Record<UserProfileKey, string> = {
  // Main titles
  myProfile: 'My Profile',
  profileSubtitle: 'Manage your personal information and security',
  
  // Tabs
  personal: 'Personal',
  security: 'Security',
  language: 'Language',
  
  // Personal section
  personalInfoTitle: 'Personal Information',
  personalInfoSubtitle: 'Update your contact details',
  fullName: 'Full Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  phone: 'Phone',
  company: 'Company (Optional)',
  
  // Avatar
  changePhoto: 'Change photo',
  removePhoto: 'Remove photo',
  confirmRemovePhoto: 'Remove profile photo',
  confirmRemovePhotoDesc: 'Are you sure you want to remove your profile photo? This action cannot be undone.',
  
  // Security section
  securityTitle: 'Access Password',
  securitySubtitle: 'Keep your account protected',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  
  // Password validation
  passwordStrength: 'Password strength',
  passwordRequirements: 'Your password must be at least 8 characters, including uppercase, lowercase letters and numbers',
  
  // Legacy information
  personalInformation: 'Personal Information',
  updatePersonalDetails: 'Update your personal details and avatar',
  updatePasswordSettings: 'Update your password and security settings',
  languageSettings: 'Language Settings',
  chooseLanguage: 'Choose your preferred language for the application',
  change: 'Change',
  remove: 'Remove',
  
  // Buttons
  savePersonalInfo: 'Save Information',
  changePassword: 'Change Password',
  saveChanges: 'Save Changes',
  updatePassword: 'Update Password',
  
  // Feedback
  successPersonalInfo: 'Information updated successfully',
  successPassword: 'Password changed successfully',
  errorGeneric: 'Could not save. Please try again',
  errorCurrentPassword: 'Incorrect current password',
  passwordsDontMatch: 'Passwords do not match',
};

